// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8O8qS","rootMobile":"styles_rootMobile__3Fq_P"};